import { Machine, assign } from "xstate";

import { THROTTLE_INTERVAL_IN_MILLISECONDS } from "./MugShotConfig";

export const measuringMachine = Machine({
  initial: "loading",
  context: {
    images: undefined,
    measurements: undefined,
    throttle_interval: THROTTLE_INTERVAL_IN_MILLISECONDS
  },
  states: {
    loading: {
      invoke: {
        src: "loadModel",
        onDone: "scanning",
      },
    },
    scanning: {
      on: {
        SCANNINGCOMPLETE: {
          target: "scanningCompletePause",
          actions: assign({ images: (context, event) => event.images }),
        },
      },
    },
    scanningCompletePause: {
      on: {
        NEXT: "analysing"
      }
    },
    analysing: {
      invoke: {
        src: "analyseImages",
        onDone: {
          target: "checkForErrors",
          actions: assign({ measurements: (context, event) => event.data }),
        },
      },
    },
    checkForErrors: {
      on: {
        success: {
          target: "complete",
        }
      }
    },
    complete: {
      type: "final",
      data: (ctx) => {
        return (({ measurements, images }) => ({
          status: "complete",
          measurements,
          images,
        }))(ctx);
      },
    },
    failed: {
      type: "final",
      data: { status: "failed" },
    },
  },
});
